import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import { adminSettings } from "../../../schemas";
import { useFormik } from "formik";
import CreatableSelect from "react-select/creatable";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GET_ADMIN_SETTINGS, UPDATE_ADMIN_SETTINGS } from "../../../env";
import {
    postRecords,
    getRecords,
    catchAsync,
    isSuccess,
    toastSuccessMessages,
    toastErrorMessages,
} from "../../../helper/helper";
import ProgressComponent from "../../../components/general/ProgressComponent";


function OneTimeCodeSettings({ subModalOneTimeSettings }) {
    // console.log("🚀 ~ GET_ADMIN_SETTINGS:", GET_ADMIN_SETTINGS)
    const handleShowHideModal = () => {
        subModalOneTimeSettings((prevShow) => !prevShow);
    };
    const [isSubmitButtonClicked, setIsSubmitButtonClicked] = useState(false);
    const [isToastAdminSettings, setIsToastAdminSettings] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [oneTimeCodeSettingDefault, setOneTimeCodeSettingDefault] = useState("");
    useEffect(() => {
        setFieldValue(
            "oneTimeCodeSetting",
            oneTimeCodeSettingDefault
        );
    }, [oneTimeCodeSettingDefault])
    const getAPIquery = {};

    const [suFormData, setSuFormData] = useState({
        oneTimeCodeSetting: oneTimeCodeSettingDefault
    });

    const {
        values,
        errors,
        handleSubmit,
        setFieldValue,
    } = useFormik({
        initialValues: suFormData,
        validationSchema: adminSettings,
        onSubmit: async (values) => {
            try {
                setIsSubmitButtonClicked(true);
                await postAdminSettingsFormData(values);
            } catch (error) {

            }
        },
    });

    const processPostRecords = (method, data) => {

        if (data?.status !== isSuccess) {
            setIsToastAdminSettings(true);
            toastErrorMessages(toast.error, data?.message, "", 500, 500);
            setIsSubmitButtonClicked(false);
            handleShowHideModal();
        } else if (
            method === "postAdminSettingsFormData" &&
            data?.status === isSuccess
        ) {
            setIsToastAdminSettings(true);
            toastSuccessMessages(toast.success, data?.message, "", 500, 500);
            setIsSubmitButtonClicked(false);
            setTimeout(() => {
                handleShowHideModal();
            }, 2000);
        } else if (method === "get" && data?.status === isSuccess) {
            const result = data?.data;
            setOneTimeCodeSettingDefault(result?.oneTimeCodeSetting);
            setIsLoading(false);
        }
    };

    const postAdminSettingsFormData = catchAsync(async (req, res) => {
        const response = await postRecords(UPDATE_ADMIN_SETTINGS, values);
        setIsSubmitButtonClicked(false);
        processPostRecords("postAdminSettingsFormData", response);
    });


    const fetchAllRecords = catchAsync(async (req, res) => {
        setIsLoading(true)
        const response = await getRecords(GET_ADMIN_SETTINGS, getAPIquery);
        // console.log("🚀 ~ fetchAllRecords ~ response:", response)
        processPostRecords("get", response);
        setIsLoading(false)
    });


    useEffect(() => {

        fetchAllRecords();

    }, []);

    const [permissionItems, setPermissionItems] = useState([
        { label: "12 Hours", value: 12 },
        { label: "24 Hours", value: 24 },
        { label: "36 Hours", value: 36 },
        { label: "48 Hours", value: 48 }
    ]);




    return (
        <>
            <div className="incidents consentCapacityAddNew">
                {isLoading ? (
                    <div className="minHeight250">
                        <ProgressComponent />
                    </div>
                ) : (
                    <form onSubmit={handleSubmit} encType="multipart/form-data">
                        <div className="formBlockContent" style={{ minHeight: "180px" }}>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <div
                                            className={`customSelectBox ${errors?.oneTimeCodeSetting ? "validationError" : ""
                                                }`}
                                        >
                                            <CreatableSelect
                                                name="oneTimeCodeSetting"
                                                value={permissionItems?.find(
                                                    (option) =>
                                                        option?.value === values?.oneTimeCodeSetting
                                                )}
                                                className="basic-multi-select cursor-pointer"
                                                classNamePrefix="select"
                                                options={permissionItems}
                                                onChange={(selectedOption) => {
                                                    setFieldValue(
                                                        "oneTimeCodeSetting",
                                                        selectedOption?.value
                                                    );
                                                }}
                                            />
                                            <label className="floatingLabel">
                                                Setting Duration
                                            </label>
                                            {errors?.oneTimeCodeSetting && (
                                                <div className="text-danger">
                                                    {errors?.oneTimeCodeSetting}
                                                </div>
                                            )}
                                        </div>
                                        <p className="mt-3">The One-Time Code settings are configured for a duration of <strong>{values?.oneTimeCodeSetting} hours</strong>.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="formActionButtons">
                            {isSubmitButtonClicked ? (
                                <Button
                                    onClick={subModalOneTimeSettings}
                                    className="btn-sm"
                                    variant="primary"
                                    disabled
                                >
                                    Loading...
                                </Button>
                            ) : (
                                <Button className="btn-sm" variant="primary" type="submit">
                                    Submit
                                </Button>
                            )}
                            <span
                                onClick={subModalOneTimeSettings}
                                className="btn btn-sm btn-outline-primary"
                            >
                                Close
                            </span>

                        </div>
                    </form>
                )}
            </div>
            {isToastAdminSettings ? <ToastContainer /> : ''}

        </>
    );
}

export default OneTimeCodeSettings;